function getActualPageCount(options) {
    const { canAddNewItem, data, itemsPerPage } = options;
    if (!data) {
        return canAddNewItem ? 1 : 0;
    }
    const currentLength = canAddNewItem ? data.length + 1 : data.length;
    const pageCount = Math.max(Math.floor(currentLength / itemsPerPage), 0);
    return currentLength % itemsPerPage > 0 ? pageCount : pageCount - 1;
}
export { getActualPageCount, };
//# sourceMappingURL=trail-utils.js.map